import {
    GET_HALL_CONFIGURATION_SUCCEEDED,
    GET_MOVIE_THEATERS_SUCCEEDED,
    STORE_SELECTED_SEATS_SUCCEEDED,
    CLEAR_HALL_CONFIGURATION_SUCCEEDED,
    GET_MOVIE_THEATERS_WITH_TICKETS_SUCCEEDED,
    GET_MOVIE_THEATERS_SEE_MORE_SUCCEEDED,
    STORE_SELECTED_COUCH_SUCCEEDED,
    STORE_SELECTED_TICKETS_SUCCEEDED,
    REMOVE_SELECTED_TICKETS_SUCCEEDED,
    GET_MOVIE_THEATERS_WITH_TICKETS_SEE_MORE_SUCCEEDED,
} from '../actions/types';

const initialState = {
    errors: {},
    hallConfiguration: null,
    selectedSeats: [],
    selectedCouch: [],
    movieTheatersTickets: {},
    selectedTickets: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_MOVIE_THEATERS_SUCCEEDED:
            return {
                ...state,
                ...action.payload
            };
        case GET_MOVIE_THEATERS_SEE_MORE_SUCCEEDED:
            return {
                ...state,
                ...action.payload
            }
        case GET_HALL_CONFIGURATION_SUCCEEDED:
            return {
                ...state,
                hallConfiguration: action.payload
            };
        case STORE_SELECTED_SEATS_SUCCEEDED:
            return {
                ...state,
                selectedSeats: action.payload
            }
        case STORE_SELECTED_COUCH_SUCCEEDED:
            return {
                ...state,
                selectedCouch: action.payload
            }
        case CLEAR_HALL_CONFIGURATION_SUCCEEDED:
            return {
                ...state,
                hallConfiguration: {},
                selectedSeats: [],
                selectedCouch: []
            }
        case GET_MOVIE_THEATERS_WITH_TICKETS_SUCCEEDED:
            return {
                ...state,
                movieTheatersTickets: action.payload
            }
        case GET_MOVIE_THEATERS_WITH_TICKETS_SEE_MORE_SUCCEEDED:
            return {
                ...state,
                movieTheatersTickets: action.payload
            }
        case STORE_SELECTED_TICKETS_SUCCEEDED:
            return {
                ...state,
                selectedTickets: action.payload
            }
        case REMOVE_SELECTED_TICKETS_SUCCEEDED:
            return {
                ...state,
                selectedTickets: action.payload
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/SHARED/reducers/movietheater.reducer.js